import React, { useState } from "react";
import "../../styles/HomeComponents/Navbar.css";
import logo from "../../assets/Images/logo.png";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/authContext";



const Navbar = () => {
  // const navigate = useNavigate();
  const { isAuthenticated, logout } = useContext(AuthContext);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;


  //👇 Universal navigation + close menu
  // const handleNavigate = (path) => {
  //   navigate(path);
  //   setIsMobileMenuOpen(false);
  // };

  // 👇 Logout + close menu
  const handleLogout = () => {
    logout();
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
          <img src={logo} alt="Strawket" className="navbar-logo" />
        </Link>
      </div>

      <div className={`navbar-links ${isMobileMenuOpen ? "active" : ""}`}>
        <Link to="/students" onClick={() => setIsMobileMenuOpen(false)}  className="nav-links">
          For students
        </Link>
        <Link to="/academies" onClick={() => setIsMobileMenuOpen(false)} className="nav-links">
          For Academies
        </Link>
        <Link to="/blog" onClick={() => setIsMobileMenuOpen(false)} className="nav-links">
          Blogs
        </Link>

        
          {/* <div className="dropdown">
            <button className="dropbtn">
              Dashboard <span className="arrow">&#9662;</span>
            </button>
            <div className="dropdown-content">
                <>
                  <button onClick={() => handleNavigate("/add-testimonial")}>
                    Add Testimonial
                  </button>
                  <button onClick={() => handleNavigate("/manage-testimonial")}>
                    Manage Testimonials
                  </button>
                  <button onClick={() => handleNavigate("/admin/users")}>
                    All Users
                  </button>
                  <button onClick={() => handleNavigate("/admin/contacts")}>
                    Manage Contacts
                  </button>
                  <button onClick={() => handleNavigate("/admin/subscribers")}>
                    Manage Subscribers
                  </button>
                  <button onClick={() => handleNavigate("/blogs/create")}>
                    Create Blogs
                  </button>
                </>
              
              
            </div>
          </div> */}

                
        {/* {isAuthenticated ? (
          <button onClick={handleLogout} className="login-button">
            Logout
          </button>
        ) : ( */}
          <div>
            <a 
      href={`${LOGIN_URL}/login`}  
      onClick={() => setIsMobileMenuOpen(false)} 
      className="login-button"
    >
      Login
    </a>
          </div>
        
      </div>

      <div
        className="hamburger"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
    </nav>
  );
};


export default Navbar;
